import { useState } from 'react';

import { Botao } from '../ds/Botao.js';
import { dispensarFaixa, emStandalone, faixaDispensada } from './instalacao.js';
import './pwa.css';

export function FaixaDeInstalacao() {
  const [visivel, setVisivel] = useState(
    () => !emStandalone() && !faixaDispensada(),
  );
  if (!visivel) return null;
  return (
    <aside className="faixa-instalacao" aria-label="Instalar o app">
      <p>
        Instale o Sheafyield: toque em Compartilhar e depois em Adicionar à Tela
        de Início.
      </p>
      {/* O `Botao` do sistema: enquanto era um `<button>` cru, a faixa
          repetia raio e respiro por conta própria, com valores fora dos
          tokens, e ficava sem o alvo de toque de `--alvo`. */}
      <Botao
        variante="secundario"
        onClick={() => {
          dispensarFaixa();
          setVisivel(false);
        }}
      >
        Depois
      </Botao>
    </aside>
  );
}
